import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Checkbox,
  Link,
  Divider,
} from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 720,
  maxWidth: "92vw",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  outline: "none",
  overflow: "hidden",
};

export default function ModalTratamientodeDatosObligatorio({
  open,
  onClose,
  onNext,
  onAcept,
  onOpenPolitica, // opcional: callback para abrir politica
  defaultChecked = false,
}) {
  const [checked, setChecked] = React.useState(defaultChecked);

  React.useEffect(() => {
    if (open) setChecked(defaultChecked);
  }, [open, defaultChecked]);

  const handleNext = (e) => {
    if (!checked) return;
    onNext?.(e);
    onClose?.();
  };

  return (
    <Modal open={open} onClose={onClose} sx={{zIndex:2}}>
      <Box sx={style}>
        {/* Content */}
        <Box sx={{ p: 3 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 18, color: "#111827" }}>
            Consulta obligatoria
          </Typography>

          <Typography sx={{ mt: 1, fontSize: 13.5, color: "#6B7280" }}>
            Para continuar, es necesario que consultes la Política de Tratamiento de Datos Personales
            y autorices el uso de tu información conforme a la ley 1581 de 2012 y el Decreto 1377 de
            2013.
          </Typography>

          {/* Checkbox line (como la imagen) */}
          <Box
            sx={{
              mt: 2.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
              userSelect: "none",
            }}
          >
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              sx={{
                p: 0.5,
                mt: "2px",
                "& .MuiSvgIcon-root": { fontSize: 20 },
              }}
            />

            <Typography sx={{ fontSize: 13.5, color: "#111827", lineHeight: 1.35 }}>
              He leído{" "}
              <Link
                component="button"
                onClick={onOpenPolitica}
                underline="hover"
                sx={{ fontWeight: 600 }}
              >
                la política  y 
           
             {" "}
           
                el aviso de privacidad
              </Link>{" "}
              autorizo el tratamiento de mis datos personales.
            </Typography>
          </Box>
        </Box>

        <Divider />

        {/* Footer actions (Regresar / Siguiente como la imagen) */}
        <Box
          sx={{
            px: 3,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            bgcolor: "#FFFFFF",
          }}
        >
          <Button
            onClick={onClose}
            startIcon={<ArrowBackIosNewRoundedIcon sx={{ fontSize: 16 }} />}
            variant="text"
            sx={{
              color: "#6B7280",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": { bgcolor: "transparent", color: "#111827" },
            }}
          >
            Regresar
          </Button>

          <Button
            onClick={handleNext}
            endIcon={<ArrowForwardIosRoundedIcon sx={{ fontSize: 16 }} />}
            variant="contained"
            disabled={!checked}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              borderRadius: 1.5,
              px: 3,
              height: 36,
              boxShadow: "none",
              "&.Mui-disabled": {
                bgcolor: "#E5E7EB",
                color: "#9CA3AF",
              },
            }}
          >
            Siguiente
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
